import { gql } from "@apollo/client";
import { GET_EMPLOYEE, GET_EMPLOYEE_ROW, GET_VISA } from "../fragments/processes";

export const ADD_UPDATE_EMPLOYEE = gql`
  ${GET_EMPLOYEE}
  mutation createEmployee(
    $_id: String
    $status: EmployeeStatus!
    $currentStatusDate: DateTime
    $currentStatusRemark: String
    $givenName: String
    $surName: String
    $passportNumber: String
    $placeOfBirth: String
    $placeOfIssue: String
    $notificationMessage: String
    $medicalStatus: MedicalStatus
    $medicalBookedDate: DateTime
    $medicalExpiryDate: DateTime
    $cocCompleted: Boolean
    $biometricsCompleted: Boolean
    $visaIssued: Boolean
    $visaIssuedDate: DateTime
    $labourIssued: Boolean
    $lmisIssuedDate: DateTime
    $ticketBooked: Boolean
    $sex: Sex!
    $dateOfBirth: DateTime
    $passportIssueDate: DateTime
    $passportExpiryDate: DateTime
    $passportScan: String
    $visa: VisaInput
    $documents: [RequiredDocuments!]
    $address: AddressInput
    $contactPerson: ContactInput
    $additionalData: AdditionalDataInput
    $education: EducationInput
    $embassyProcess: EmbassyProcessInput
    $flight: FlightProcessInput
    $workExperience: [WorkExperienceInput!]
    $owner: CompanyInput
    $partner: CompanyInput
    $selectionDueDate: DateTime
    $parentCompany: CompanyInput
    $prospects: [CompanyInput!]
    $clearVisa: Boolean
    $calling: Boolean
  ) {
    createEmployee(
      input: {
        _id: $_id
        status: $status
        currentStatusDate: $currentStatusDate
        currentStatusRemark: $currentStatusRemark
        givenName: $givenName
        surName: $surName
        passportNumber: $passportNumber
        placeOfBirth: $placeOfBirth
        placeOfIssue: $placeOfIssue
        notificationMessage: $notificationMessage
        medicalStatus: $medicalStatus
        medicalBookedDate: $medicalBookedDate
        medicalExpiryDate: $medicalExpiryDate
        cocCompleted: $cocCompleted
        biometricsCompleted: $biometricsCompleted
        visaIssued: $visaIssued
        visaIssuedDate: $visaIssuedDate
        labourIssued: $labourIssued
        lmisIssuedDate: $lmisIssuedDate
        ticketBooked: $ticketBooked
        sex: $sex
        dateOfBirth: $dateOfBirth
        passportIssueDate: $passportIssueDate
        passportExpiryDate: $passportExpiryDate
        passportScan: $passportScan
        documents: $documents
        address: $address
        visa: $visa
        contactPerson: $contactPerson
        additionalData: $additionalData
        education: $education
        embassyProcess: $embassyProcess
        flight: $flight
        workExperience: $workExperience
        owner: $owner
        partner: $partner
        selectionDueDate: $selectionDueDate
        parentCompany: $parentCompany
        prospects: $prospects
        clearVisa: $clearVisa
        calling: $calling
      }
    ) {
      ...getEmployee
    }
  }
`;

export const UPDATE_EMPLOYEE_STATUS = gql`
  ${GET_EMPLOYEE}
  mutation updateEmployeeStatus(
    $_id: String!
    $status: EmployeeStatus!
    $currentStatusDate: DateTime
    $currentStatusRemark: String
    $cocCompleted: Boolean
    $medicalStatus: MedicalStatus
    $medicalBookedDate: DateTime
    $medicalExpiryDate: DateTime
    $biometricsCompleted: Boolean
    $visaIssued: Boolean
    $visaIssuedDate: DateTime
    $labourIssued: Boolean
    $lmisIssuedDate: DateTime
    $ticketBooked: Boolean
    $flight: FlightProcessInput
  ) {
    updateEmployeeStatus(
      input: {
        _id: $_id
        status: $status
        currentStatusDate: $currentStatusDate
        currentStatusRemark: $currentStatusRemark
        cocCompleted: $cocCompleted
        medicalStatus: $medicalStatus
        medicalBookedDate: $medicalBookedDate
        medicalExpiryDate: $medicalExpiryDate
        biometricsCompleted: $biometricsCompleted
        visaIssued: $visaIssued
        visaIssuedDate: $visaIssuedDate
        labourIssued: $labourIssued
        lmisIssuedDate: $lmisIssuedDate
        ticketBooked: $ticketBooked
        flight: $flight
      }
    ) {
      ...getEmployee
    }
  }
`;
export const ADD_EMPLOYEE_STATUS_REMARK = gql`
  ${GET_EMPLOYEE}
  mutation addEmployeeStatusRemark(
    $_id: String!
    $remark: String!
    $effectiveDate: DateTime
  ) {
    addEmployeeStatusRemark(
      input: { _id: $_id, remark: $remark, effectiveDate: $effectiveDate }
    ) {
      ...getEmployee
    }
  }
`;
export const BULK_UPDATE_EMPLOYEE_STATUS = gql`
  mutation bulkUpdateEmployeeStatus(
    $ids: [String!]!
    $status: EmployeeStatus!
    $currentStatusDate: DateTime
    $currentStatusRemark: String
  ) {
    bulkUpdateEmployeeStatus(
      input: {
        ids: $ids
        status: $status
        currentStatusDate: $currentStatusDate
        currentStatusRemark: $currentStatusRemark
      }
    ) {
      updated
      failed
      errors
    }
  }
`;

export const UPDATE_BOOKING_FOLLOW_UP = gql`
  ${GET_EMPLOYEE_ROW}
  mutation updateBookingFollowUp(
    $employeeId: String!
    $type: BookingFollowUpType!
    $status: BookingFollowUpStatus!
    $scheduledDate: DateTime
    $remark: String
  ) {
    updateBookingFollowUp(
      input: {
        employeeId: $employeeId
        type: $type
        status: $status
        scheduledDate: $scheduledDate
        remark: $remark
      }
    ) {
      ...getEmployeeRow
    }
  }
`;

export const BULK_UPDATE_BOOKING_FOLLOW_UP = gql`
  mutation bulkUpdateBookingFollowUp(
    $ids: [String!]!
    $type: BookingFollowUpType!
    $status: BookingFollowUpStatus!
    $scheduledDate: DateTime
    $remark: String
  ) {
    bulkUpdateBookingFollowUp(
      input: {
        ids: $ids
        type: $type
        status: $status
        scheduledDate: $scheduledDate
        remark: $remark
      }
    ) {
      updated
      failed
      errors
    }
  }
`;

export const REMOVE_EMPLOYEE = gql`
  mutation removeAnEmployee($id: String!) {
    deleteEmployee(id: $id) {
      affectedRows
    }
  }
`;

export const CLEAR_EMPLOYEE_ATTACHMENT = gql`
  ${GET_EMPLOYEE}
  mutation clearEmployeeAttachment($employeeId: String!, $type: PhotoTypes!) {
    clearEmployeeAttachment(employeeId: $employeeId, type: $type) {
      ...getEmployee
    }
  }
`;

export const ADD_UPDATE_VISA = gql`
  ${GET_VISA}
  mutation createVisa(
    $_id: String
    $visaNumber: String!
    $visaQty: Int!
    $fullName: String!
    $passportNumber: String
    $wekalaDate: String
    $salary: Int
    $remarks: String
    $firstTime: Boolean!
    $goodLooking: Boolean!
    $writeRead: Boolean!
    $currency: CurrencyTypes!
    $profession: ProfessionalTypes!
    $religion: ReligionTypes!
    $ageCategory: AgeCategory!
    $complexion: Complexion!
    $status: VisaStatus!
    $visaType: VisaTypes
    $address: AddressInput
    $owner: CompanyInput
  ) {
    createVisa(
      input: {
        _id: $_id
        visaNumber: $visaNumber
        fullName: $fullName
        passportNumber: $passportNumber
        wekalaDate: $wekalaDate
        visaQty: $visaQty
        salary: $salary
        currency: $currency
        remarks: $remarks
        firstTime: $firstTime
        goodLooking: $goodLooking
        writeRead: $writeRead
        profession: $profession
        religion: $religion
        ageCategory: $ageCategory
        complexion: $complexion
        status: $status
        visaType: $visaType
        address: $address
        owner: $owner
      }
    ) {
      ...getVisa
    }
  }
`;

export const REMOVE_VISA = gql`
  mutation removeAVisa($id: String!) {
    deleteVisa(id: $id) {
      affectedRows
    }
  }
`;

export const GENERATE_LINK = gql`
  mutation generateLink($headerId: String, $ids: [String!]!) {
    generateLink(input: { employeeIds: $ids, headerId: $headerId }) {
      _id
      link

      employees {
        _id
        givenName
      }
    }
  }
`;

export const SHARE_BY_EMAIL = gql`
  mutation shareLinkByEmail($email: String, $link: String) {
    shareLinkByEmail(input: { email: $email, link: $link }) {
      email
      link
    }
  }
`;

export const UPLOAD_FILE = gql`
  mutation uploadFile($_id: String!, $type: PhotoTypes!, $avatar: Upload!) {
    uploadFile(input: { _id: $_id, type: $type, avatar: $avatar }) {
      _id
      type
      avatar
    }
  }
`;

export const SEND_WHATSAPP_DOCUMENT = gql`
  mutation sendWhatsAppDocument($input: SendWhatsAppDocumentInput!) {
    sendWhatsAppDocument(input: $input) {
      success
      messageId
    }
  }
`;

export const LINK_EMPLOYEE_VISA = gql`
  ${GET_EMPLOYEE}

  mutation assignEmployeeVisa($ids: [String!]!) {
    assignEmployeeVisa(input: { ids: $ids }) {
      ...getEmployee
    }
  }
`;
export const ADD_UPDATE_NOTIFICATION = gql`
  mutation createNotification(
    $_id: String
    $message: String!
    $priority: NotificationPriority
    $status: NotificationStatus
  ) {
    createNotification(
      input: {
        _id: $_id
        message: $message
        priority: $priority
        status: $status
      }
    ) {
      _id
      message
      priority
      status
      from {
        _id
        displayName
        header
      }
      employee {
        _id
        status
        passportNumber
        notificationMessage
        givenName
        surName
        facePhoto
        standPhoto
        passportScan
        sex
        dateOfBirth
        selectionDueDate
      }
    }
  }
`;
export const MARK_AS_READ_NOTIFICATION = gql`
  mutation markNotificationAsRead($id: String!) {
    markNotificationAsRead(id: $id)
  }
`;

export const MARK_ALL_AS_READ_NOTIFICATIONS = gql`
  mutation markAllNotificationsAsRead {
    markAllNotificationsAsRead
  }
`;

export const REMOVE_NOTIFICATION = gql`
  mutation removeNotification($id: String!) {
    deleteNotification(id: $id) {
      affectedRows
    }
  }
`;
